import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { Encounter } from 'app/core/interfaces/encounter';
import { EncounterService } from 'app/core/http/services/encounter.service';
import { RevenueSummary, RevenueItem } from 'app/core/interfaces/revenue';

@Component({
  selector: 'practitioner-revenue',
  templateUrl: './revenue.component.html',
  styleUrls: ['./revenue.component.scss'],
})
export class PractitionerRevenueComponent extends BaseComponent implements OnInit {
  revenueSummary: RevenueSummary = { total: 0, month: 0, year: 0 };
  revenueItems: RevenueItem[] = [];
  filteredItems: RevenueItem[] = [];
  pagedItems: RevenueItem[] = [];
  startDate: string = '';
  endDate: string = '';
  itemsPerPage = 10;
  currentPage = 1;
  practitionerLogged: any = {};
  encounters: Encounter[] = [];

  constructor(
    private injector: Injector,
    private encounterService: EncounterService,
  ) {
    super(injector);
  }

  ngOnInit() {
    const user = this.getUserLogged();
    this.practitionerLogged = {
      practitioner_id: user.id,
      name: user.name,
      email: user.email,
    };
    this.loadEncounters();
  }

  private loadEncounters() {
    this.encounterService.listByPractitionerNew(this.practitionerLogged.practitioner_id).subscribe({
      next: (encounters: Encounter[]) => {
        this.encounters = encounters;
        this.buildRevenue();
      },
      error: (err) => console.error('Erro ao buscar encounters', err),
    });
  }

  private buildRevenue() {
    this.revenueItems = this.encounters
      .filter((encounter: any) => !!encounter.value)
      .map((encounter: any) => {
        const raw = new Date(encounter.startDate.replace(' ', 'T'));
        return {
          date: raw.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' }),
          rawDate: raw,
          patient: encounter.patient?.name || '-',
          service: encounter.name || encounter.type,
          amount: parseFloat(encounter.value),
        } as RevenueItem;
      })
      .sort((a, b) => b.rawDate.getTime() - a.rawDate.getTime());

    this.filteredItems = [...this.revenueItems];
    this.currentPage = 1;
    this.updatePagedItems();
    this.calculateSummary();
  }

  private calculateSummary() {
    const now = new Date();
    const month = now.getMonth();
    const year = now.getFullYear();

    this.revenueSummary.total = this.revenueItems.reduce((sum, i) => sum + i.amount, 0);
    this.revenueSummary.month = this.revenueItems
      .filter((i) => i.rawDate.getMonth() === month && i.rawDate.getFullYear() === year)
      .reduce((sum, i) => sum + i.amount, 0);
    this.revenueSummary.year = this.revenueItems.filter((i) => i.rawDate.getFullYear() === year).reduce((sum, i) => sum + i.amount, 0);
  }

  filterByDate() {
    if (this.startDate && this.endDate) {
      const start = new Date(this.startDate);
      const end = new Date(this.endDate);
      this.filteredItems = this.revenueItems.filter((i) => i.rawDate >= start && i.rawDate <= end);
    } else {
      this.filteredItems = [...this.revenueItems];
    }
    this.currentPage = 1;
    this.updatePagedItems();
  }

  private updatePagedItems() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    this.pagedItems = this.filteredItems.slice(start, start + this.itemsPerPage);
  }

  get totalPages(): number {
    return Math.ceil(this.filteredItems.length / this.itemsPerPage) || 1;
  }
  get pages(): number[] {
    return Array(this.totalPages)
      .fill(0)
      .map((_, i) => i + 1);
  }
  changePage(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.updatePagedItems();
  }
  prevPage() {
    this.changePage(this.currentPage - 1);
  }
  nextPage() {
    this.changePage(this.currentPage + 1);
  }

  formatCurrency(value: number): string {
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }
}
